import ActivityImportTable from '@app/components/imports/components/activity-import-table';
import { PageHeader } from '@app/components/layout/page/components/page-header';
import Page from '@app/components/layout/page/page';
import { useDataTableQueryState } from '@app/hooks/use-data-table-query-state';
import SoldGoodsImportPageToolbar from '@app/sold-goods/components/sold-goods-imports-list-page-toolbar';
import {
  useGetImports,
  useImportsWithProgress,
} from '@shared/api/hooks/ccf/imports';
import { ImportTypeEnum, OperationReportTypeEnum } from '@shared/api/types';
import { parseAsString, useQueryState } from 'nuqs';

export default function SoldGoodsImportsListPage() {
  const { page, perPage } = useDataTableQueryState();

  const [fileName] = useQueryState('fileName', parseAsString);

  const { data, status } = useGetImports({
    page: page,
    page_size: perPage,
    importType: ImportTypeEnum.sold_goods,
    search: fileName || undefined,
  });

  const mergedData = useImportsWithProgress(data);

  return (
    <Page name="Sold goods imports">
      <PageHeader
        name="Sales imports"
        toolbar={<SoldGoodsImportPageToolbar />}
      />
      <ActivityImportTable
        data={mergedData!}
        pageSize={perPage}
        status={status}
        reportType={OperationReportTypeEnum.sales}
      />
    </Page>
  );
}
